const READONLY_UNSUPPORTED_INPUT_TYPES = new Set([
  'button',
  'checkbox',
  'color',
  'file',
  'image',
  'radio',
  'range',
  'reset',
  'submit',
]);

const PDF_OWN_FOCUSABLE_SELECTOR =
  'a, button, input, select, textarea, [tabindex], [contenteditable]';

export function lockPdfOwnInnerElement(root: HTMLElement) {
  lockPdfOwnControl(root);
  for (const node of root.querySelectorAll(PDF_OWN_FOCUSABLE_SELECTOR)) {
    if (node instanceof HTMLElement) lockPdfOwnControl(node);
  }
}

/**
 * WebViewer 12.1 builds a Sign Here control on PDF-native signature widgets.
 * Hide it and drop the prompt so it is not treated as the field's value.
 */
export function hidePdfOwnSignHereElement(el: HTMLElement) {
  el.hidden = true;
  el.replaceChildren();
}

function lockPdfOwnControl(el: HTMLElement) {
  el.tabIndex = -1;

  if (el instanceof HTMLTextAreaElement) {
    el.readOnly = true;
    return;
  }

  if (el instanceof HTMLInputElement) {
    if (READONLY_UNSUPPORTED_INPUT_TYPES.has(el.type)) {
      el.disabled = true;
      return;
    }
    el.readOnly = true;
    return;
  }

  if (el instanceof HTMLSelectElement || el instanceof HTMLButtonElement) {
    el.disabled = true;
    return;
  }

  if (el.isContentEditable) el.contentEditable = 'false';
}
